<app-alert></app-alert>
<section class="panel panel-default">
  <div class="card-header">
    <title>MGT-1 Register of Members</title>
    <span class="cat__core__title">
      <strong id="pageTitle">MGT-1 Register of Members</strong>
    </span>
    <span style="float: right">
      <!-- <a routerLink="/mgt1list"> -->
        <button class="btn btn-sm btn-default pull-right btn-back" type="button" (click)="backMGT1()" >
          <i class=" fa fa-chevron-circle-left"></i>
          Back
        </button>
      <!-- </a> -->
    </span>


    <span style="float:right">
      <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()"
        type="button" *ngIf="restrictmgt1">
        <span>
          <i class="fa fa-save"></i>&nbsp;Generate Output</span>
      </button>
    </span>

  </div>

  <div class="row">
    <div class="col-lg-12" id="directorTabContainer" style="background-color: white;">
      <ul class="nav nav-tabs" role="tablist" style="width: auto">
        <li class="nav-item" style="width: auto">
          <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#detailsOfShares" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}"
            role="tab">
            Details of Shares
          </a>
        </li>
        <li class="nav-item" style="width: auto">
          <a class="nav-link" *ngIf="restrictmgt1" href="javascript: void(0);" data-toggle="tab" data-target="#personalDetails" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}"
            role="tab">
            Personal Details
          </a>
        </li>
        <li class="nav-item" style="width: auto">
          <a class="nav-link" *ngIf="restrictmgt1" href="javascript: void(0);" data-toggle="tab" data-target="#detailsOfMember" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}"
            role="tab">
            Details of Member
          </a>
        </li>
        <li class="nav-item" style="width: auto">
          <a class="nav-link" *ngIf="restrictmgt1" href="javascript: void(0);" data-toggle="tab" data-target="#detailsOfShareholding"
            role="tab" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}">
            Details of Shareholding
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <!-- details of shares -->
        <div class="tab-pane active" id="detailsOfShares" role="tabcard">
          <div class="modal-body">

            <div class="form-group col-sm-6 col-lg-12">
              <!-- <div  class="row" > -->
              <form [formGroup]='detailsOfSharesForm'>
                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Class of shares</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>

                    <select class="form-control" [formControl]="detailsOfSharesForm.controls['selectTypes']" style="padding:6px;">
                      <option value="" [selected]="true">Select</option>
                      <option value="Equity">Equity</option>
                      <option value="Preference">Preference</option>
                      <option value="Sweat Equity"> Sweat Equity</option>
                      <option value="Employee Stock Option">
                        Employee Stock Option
                      </option>
                      <option value="Others">
                        Others
                      </option>

                    </select>
                    <div *ngIf="detailsOfSharesForm.controls['selectTypes'].hasError('required') && detailsOfSharesForm.controls['selectTypes'].touched"
                      class="form-control-error-custom">
                      Selection is required
                    </div>
                  </div>

                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Nominal value per share (in Rs.) </label>
                    <input type="text" class="form-control" [formControl]="detailsOfSharesForm.controls['nominalValuePerUnit']">
                    <div *ngIf="detailsOfSharesForm.controls['nominalValuePerUnit'].hasError('pattern')|| detailsOfSharesForm.controls['nominalValuePerUnit'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Nominal value per share is invalid
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Total shares held</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="detailsOfSharesForm.controls['totalNoOfSharesHeld']">
                    <div *ngIf="detailsOfSharesForm.controls['totalNoOfSharesHeld'].hasError('pattern')|| detailsOfSharesForm.controls['totalNoOfSharesHeld'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Total shares held is invalid
                    </div>
                    <div *ngIf="detailsOfSharesForm.controls['totalNoOfSharesHeld'].hasError('required') && detailsOfSharesForm.controls['totalNoOfSharesHeld'].touched"
                      class="form-control-error-custom">
                      Total shares held is required
                    </div>
                  </div>
                  <div class="form-group col-md-6 col-sm-6 col-xs-12">
                    <label>Folio No./ Demat A/c No.</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <input type="text" class="form-control" (keydown)="noBlankSpaceAtStart($event)"
                      [formControl]="detailsOfSharesForm.controls['folioNoDematAcNo']">
                    <div *ngIf="detailsOfSharesForm.controls['folioNoDematAcNo'].hasError('pattern')|| detailsOfSharesForm.controls['folioNoDematAcNo'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Folio No./ Demat A/c No. is invalid
                    </div>
                    <div *ngIf="detailsOfSharesForm.controls['folioNoDematAcNo'].hasError('required') && detailsOfSharesForm.controls['folioNoDematAcNo'].touched"
                      class="form-control-error-custom">
                      Folio No./ Demat A/c No. is required
                    </div>
                  </div>
                </div>
              </form>


              <div class="form-group" align="right" *ngIf="!restrictmgt1">
                <button class="btn btn-sm btn-primary" (click)="saveDetailsOfSharesForm()" type="button" [disabled]="!(detailsOfSharesForm.valid) || disabledOnClick">
                  <span id="saveUpdateDirector">
                    <i class="fa fa-save"></i>&nbsp;Save </span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="restrictmgt1">
                <button class="btn btn-sm btn-primary" (click)="updateDetailsOfSharesForm(editParticularId._id)" type="button" [disabled]="!(detailsOfSharesForm.valid) || disabledOnClick">
                  <span id="saveUpdateDirector">
                    <i class="fa fa-save"></i>&nbsp;Update </span>
                </button>
              </div>
              <!-- </div> -->
            </div>

          </div>
        </div>

        <!-------------------------------------------------- personal details --------------------------------------------->

        <div class="tab-pane" id="personalDetails" role="tabcard">
          <div class="modal-body">
            <div class="form-group">

              <form [formGroup]='personaldetailsForm'>
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Types of Shareholders</label>
                    <span _ngcontent-c2="" style="color: red;">*</span>
                    <select class="form-control" (change)="changeTypesOfShareholders(); typesOfShareholder(personaldetailsForm.controls['typesOfShareholders'].value);"
                      [formControl]="personaldetailsForm.controls['typesOfShareholders']" style="padding:6px;">
                      <option value="" [selected]="true">Select Type</option>
                      <option value="Individual">Individual</option>
                      <option value="Body Corporate">Body Corporate</option>
                      <option value="Others">Others</option>
                    </select>
                    <div *ngIf="personaldetailsForm.controls['typesOfShareholders'].hasError('required') && personaldetailsForm.controls['typesOfShareholders'].touched"
                      class="form-control-error-custom">
                      Types of Shareholders is required
                    </div>
                  </div>
                </div>

                <!--------------------- Individual Shareholders --------------------->
                <div *ngIf="typeOfShareholder == 'Individual'">
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Name of the member</label>
                      <span _ngcontent-c1="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls.nameOfMember">
                      <div class="form-control-error-custom" *ngIf="personaldetailsForm.controls['nameOfMember'].hasError('required') && personaldetailsForm.controls['nameOfMember'].touched">
                        Name of the member is required
                      </div>
                      <div *ngIf="personaldetailsForm.controls['nameOfMember'].hasError('pattern') || personaldetailsForm.controls['nameOfMember'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of the member is invalid
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Joint holders</label>
                      <div class="form-group">
                        <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                          <input id="jointHoldersYes" type="radio" [formControl]="personaldetailsForm.controls['jointHolders']" style="position:absolute"
                            name="jointHolders" value="yes" class="form-check-input" (click)="jointHolderYesClick()">
                          <label for="jointHoldersYes" ng style="padding: 0 29px 0px 0px">Yes</label>
                        </div>
                        <div class="md-radio md-radio-inline" style="display: inline-block">
                          <input id="jointHoldersNo" type="radio" selected [formControl]="personaldetailsForm.controls['jointHolders']" style="position:absolute"
                            name="jointHolders" value="no" class="form-check-input" (click)="jointHolderNoClick()">
                          <label for="jointHoldersNo">No</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="isJointHolder=='yes'">
                      <label>Name of joint holders, if any</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls.nameOfjointHolders">
                      <div *ngIf="personaldetailsForm.controls['nameOfjointHolders'].hasError('pattern')|| personaldetailsForm.controls['nameOfjointHolders'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of joint holders is invalid
                      </div>
                    </div>
                  </div>
                  <div class="row">

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Address</label>
                      <textarea type="text" class="form-control" [formControl]="personaldetailsForm.controls.address"></textarea>
                      <div *ngIf="personaldetailsForm.controls['address'].hasError('pattern')|| personaldetailsForm.controls['address'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Address is invalid
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>PAN</label>
                      <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['panNo']">
                      <div *ngIf="personaldetailsForm.controls['panNo'].hasError('pattern')|| personaldetailsForm.controls['panNo'].hasError('maxlength')"
                        class="form-control-error-custom">
                        PAN is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="isJointHolder=='yes'">
                      <label>Joint holder's PAN</label>
                      <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['jointHoldersPanNo']">
                      <div *ngIf="personaldetailsForm.controls['jointHoldersPanNo'].hasError('pattern')|| personaldetailsForm.controls['jointHoldersPanNo'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Joint holder's PAN is invalid
                      </div>
                    </div>

                  </div>

                  <div class="row">

                    <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                      <label>Unique Identification No.</label>{{uniqueIdentification}}
                      <select _ngcontent-c2="" class="form-control " [formControl]="personaldetailsForm.controls['uin']" style="padding:6px;" (change)="uinChanged()">
                        <option value="" [selected]="true">Select Types</option>
                        <option _ngcontent-c2="" value="passport" [selected]="uniqueIdentification=='passport'">
                          Passport</option>
                        <option _ngcontent-c2="" value="aadhar" [selected]="uniqueIdentification=='aadhar'">Aadhar Number
                        </option>
                        <option _ngcontent-c2="" value="voterId" [selected]="uniqueIdentification=='voterId'">Voter's Id
                        </option>
                        <option _ngcontent-c2="" value="others" [selected]="uniqueIdentification=='others'">others
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.uin.value == 'passport' ">
                      <label>Passport Number</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['passportNumber']">
                      <div *ngIf="personaldetailsForm.controls['passportNumber'].hasError('pattern')|| personaldetailsForm.controls['passportNumber'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Passport Number is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.uin.value == 'aadhar'">
                      <label>Aadhaar Number</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['adharNumber']">
                      <div *ngIf="personaldetailsForm.controls['adharNumber'].hasError('pattern')|| personaldetailsForm.controls['adharNumber'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Aadhaar Number is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.uin.value == 'voterId' ">
                      <label>Voter's Id</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['voterId']">
                      <div *ngIf="personaldetailsForm.controls['voterId'].hasError('pattern')|| personaldetailsForm.controls['voterId'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Voter's Id is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="personaldetailsForm.controls.uin.value == 'others'">
                      <label>Others</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['others']">
                      <div *ngIf="personaldetailsForm.controls['others'].hasError('pattern')|| personaldetailsForm.controls['others'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Others is invalid
                      </div>
                    </div>

                    <div _ngcontent-c2="" class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Nationality</label>
                      <!-- <input type="text" class="form-control"
                        [formControl]="personaldetailsForm.controls['nationality']"> -->
                      <select class="form-control" [formControl]="personaldetailsForm.controls['nationality']" style="padding:6px;">
                        <option value="">Select</option>
                        <option *ngFor="let country of countryList" [selected]="country.Country==personaldetailsForm.controls['nationality'].value"
                          [value]="country.Country">
                          {{country.Country}}
                        </option>

                        <!-- <option value="Indian">Indian</option> -->
                      </select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>E-mail Id</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['emailid']">
                      <div *ngIf="personaldetailsForm.controls['emailid'].hasError('pattern')|| personaldetailsForm.controls['emailid'].hasError('maxlength')"
                        class="form-control-error-custom">
                        E-mail Id is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Father Name</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['fatherName']">
                      <div *ngIf="personaldetailsForm.controls['fatherName'].hasError('pattern')|| personaldetailsForm.controls['fatherName'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Father Name is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Mother Name</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['motherName']">
                      <div *ngIf="personaldetailsForm.controls['motherName'].hasError('pattern')|| personaldetailsForm.controls['motherName'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Mother Name is invalid
                      </div>
                    </div>
                  </div>


                  <div class="row">

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>In case member is a minor</label>
                      <div class="form-group">
                        <div class="md-radio md-radio-inline" style="display: inline-block;margin-left:19px">
                          <input id="minorYes" type="radio" (change)="memberisMinorChanged()" [formControl]="personaldetailsForm.controls['inCaseMemberisMinor']"
                            style="position:absolute" name="isMinor" value="yes" class="form-check-input" (click)='showMinorYesClick()'>
                          <label for="minorYes" ng-model="yes" style="padding: 0 29px 0px 0px">Yes</label>
                        </div>
                        <div class="md-radio md-radio-inline" style="display: inline-block">
                          <input id="minorNo" type="radio" [formControl]="personaldetailsForm.controls['inCaseMemberisMinor']" style="position:absolute"
                            name="isMinor" value="no" class="form-check-input" (click)='hideMinorNoClick()'>
                          <label for="minorNo" ng-model="no">No</label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="isMinor=='yes'">
                      <label>Date of Birth</label>
                      <div class="input-group" (click)="$event.stopPropagation()">
                        <input class="form-control" [formControl]="personaldetailsForm.controls.dob" [(ngModel)]="dateOfBirth" style="padding:6px;z-index: 0;"
                          placeholder="dd-mm-yyyy" ngbDatepicker #g="ngbDatepicker" (click)="g.toggle();">
                        <button class="input-group-addon" (click)="g.toggle();" type="button">
                          <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                        </button>
                      </div>

                      <!-- <div class="input-group" (click)="$event.stopPropagation()">
                          <input class="form-control" [formControl]="personaldetailsForm.controls.dob"
                            style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #g="ngbDatepicker"
                            (click)="g.toggle();b.close();c.close();dt.close();d.close();a.close()"
                            [(ngModel)]="dateOfBirth">
                          <button class="input-group-addon" (click)="g.toggle();b.close();c.close();dt.close();d.close();a.close()"
                            type="button">
                            <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                          </button>
                        </div> -->

                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="isMinor=='yes'">
                      <label>Name and Address of Guardian</label>
                      <textarea class="form-control" [formControl]="personaldetailsForm.controls.nameAndAddressOfGuardian" maxlength="200"> </textarea>
                      <div *ngIf="personaldetailsForm.controls['nameAndAddressOfGuardian'].hasError('pattern')|| personaldetailsForm.controls['nameAndAddressOfGuardian'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name and Address of Guardian is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12 " *ngIf="isMinor=='no' ">
                      <label>Marital Status</label>

                      <select class="form-control " (change)="maritialStatusChanged()" [formControl]="personaldetailsForm.controls['maritialStatus']"
                        style="padding:6px;">
                        <option value="" [selected]="true">Select Type</option>
                        <option [selected]="minorMaritialStatus=='single'" value="single">Single</option>
                        <option [selected]="minorMaritialStatus=='married'" value="married">Married</option>
                      </select>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12" *ngIf="isMinor=='no' && personaldetailsForm.controls['maritialStatus'].value == 'married'">
                      <label>Name of the Spouse</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['spouseName']">

                      <div *ngIf="personaldetailsForm.controls['spouseName'].hasError('pattern') || personaldetailsForm.controls['spouseName'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of the Spouse is invalid
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Occupation</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['occupation']">
                      <div *ngIf="personaldetailsForm.controls['occupation'].hasError('pattern')|| personaldetailsForm.controls['occupation'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Occupation is invalid
                      </div>
                    </div>
                  </div>
                </div>
                <!--------------------- Individual Shareholders ------------------------->

                <!--------------------- Body Corporate Shareholders --------------------->

                <div *ngIf="typeOfShareholder== 'Body Corporate'">
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Name of the member</label>
                      <span _ngcontent-c1="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['nameOfMember']">
                      <div class="form-control-error-custom" *ngIf="personaldetailsForm.controls['nameOfMember'].hasError('required') && personaldetailsForm.controls['nameOfMember'].touched">
                        Name of the member is required
                      </div>
                      <div *ngIf="personaldetailsForm.controls['nameOfMember'].hasError('pattern')|| personaldetailsForm.controls['nameOfMember'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of the member is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Registered address</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['address']">
                      <div *ngIf="personaldetailsForm.controls['address'].hasError('pattern')|| personaldetailsForm.controls['address'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Registered address is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>PAN</label>
                      <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['panNo']">
                      <div *ngIf="personaldetailsForm.controls['panNo'].hasError('pattern')|| personaldetailsForm.controls['panNo'].hasError('maxlength')"
                        class="form-control-error-custom">
                        PAN is invalid
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>CIN/ Registration No.</label>
                      <span _ngcontent-c1="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['cinRegistrationNoB']">
                      <div class="form-control-error-custom" *ngIf="personaldetailsForm.controls['cinRegistrationNoB'].hasError('required') && personaldetailsForm.controls['cinRegistrationNoB'].touched">
                        CIN/ Registration No. is required
                      </div>
                      <div *ngIf="personaldetailsForm.controls['cinRegistrationNoB'].hasError('pattern')|| personaldetailsForm.controls['cinRegistrationNoB'].hasError('maxlength')"
                        class="form-control-error-custom">
                        CIN/ Registration No. is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>E-mail Id</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['emailid']">
                      <div *ngIf="personaldetailsForm.controls['emailid'].hasError('pattern')|| personaldetailsForm.controls['emailid'].hasError('maxlength')"
                        class="form-control-error-custom">
                        E-mail Id is invalid
                      </div>
                    </div>
                  </div>

                  <section class="panel panel-default">
                    <div class="panel-heading">
                      <h5 class="panel-title">Authorised Signatory</h5>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                          <label>Name</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['nameB']">
                          <div *ngIf="personaldetailsForm.controls['nameB'].hasError('pattern')|| personaldetailsForm.controls['nameB'].hasError('maxlength')"
                            class="form-control-error-custom">
                            Name is invalid
                          </div>
                        </div>
                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                          <label>Designation</label>
                          <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['designationB']">
                          <div *ngIf="personaldetailsForm.controls['designationB'].hasError('pattern')|| personaldetailsForm.controls['designationB'].hasError('maxlength')"
                            class="form-control-error-custom">
                            Designation is invalid
                          </div>
                        </div>
                        <div class="form-group col-md-4 col-sm-6 col-xs-12">
                          <label>Board Resolution Date</label>
                          <div class="input-group" (click)="$event.stopPropagation()">
                            <input class="form-control" [(ngModel)]="dateOfBoardResolution" [formControl]="personaldetailsForm.controls.boardResolutionDateB"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle();">
                            <button class="input-group-addon" (click)="b.toggle();" type="button">
                              <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="!fileAvailable">
                          <label>Upload copy of Resolution</label>

                          <input type="file" class="form-control" (change)="fileChangeEvent($event)" accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4">
                          <!-- [formControl]="personaldetailsForm.controls['uploadCopyOfResolutionB']"> -->
                          <span style="color: red" *ngIf="!fileExtension">Please upload valid file format.</span>
                        </div>

                        <div class="form-group col-md-6 col-sm-6 col-xs-12" *ngIf="fileAvailable">
                          <label>Upload copy of Resolution</label>

                          <div>
                            <input type="text" data-toggle="tooltip" [title]="resolutionFileName" [formControl]="personaldetailsForm.controls.uploadCopyOfResolutionB"
                              [(ngModel)]="resolutionFileName" readonly='true' class='form-control col-md-5' style="display: inline-block;">
                            <button type="button" class="btn-sm btn btn-primary form-control col-md-1" (click)='downloadCtcDoc(documentManagementID);'>
                              <i class="fa fa-download"></i>
                            </button>
                            <button type="button" class="btn-sm btn btn-primary  form-control col-md-2" (click)='addFilesOnUpdate();'>Add New</button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                <!--------------------- Body Corporate Shareholders --------------------->

                <!--------------------- others Shareholders --------------------->
                <div *ngIf="typeOfShareholder == 'Others'">
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Name of member</label>
                      <span _ngcontent-c1="" style="color: red;">*</span>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['nameOfMember']">
                      <div *ngIf="personaldetailsForm.controls['nameOfMember'].hasError('pattern')|| personaldetailsForm.controls['nameOfMember'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Name of member is invalid
                      </div>
                      <div *ngIf="personaldetailsForm.controls['nameOfMember'].hasError('required') && personaldetailsForm.controls['nameOfMember'].touched"
                        class="form-control-error-custom">
                        Name of member is required
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>Address</label>
                      <textarea class="form-control" [formControl]="personaldetailsForm.controls.address" maxlength="200"> </textarea>
                      <div *ngIf="personaldetailsForm.controls['address'].hasError('pattern')|| personaldetailsForm.controls['address'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Address is invalid
                      </div>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>PAN</label>
                      <input type="text" class="form-control upperCase" [formControl]="personaldetailsForm.controls['panNo']">
                      <div *ngIf="personaldetailsForm.controls['panNo'].hasError('pattern')|| personaldetailsForm.controls['panNo'].hasError('maxlength')"
                        class="form-control-error-custom">
                        PAN is invalid
                      </div>
                    </div>

                  </div>

                  <div class="row">

                    <!-- <div class="form-group col-md-4 col-sm-6 col-xs-12 ">
                      <label>Unique Identification No.</label>
                      <select _ngcontent-c2="" class="form-control ng-pristine ng-valid ng-touched"
                        [formControl]="personaldetailsForm.controls['uin']" style="padding:6px;"
                        (change)="uinChanged()">

                        <option  _ngcontent-c2="" value="" [selected]="true">Select Types</option>
                        <option _ngcontent-c2="" value="passport" [selected]="uniqueIdentification=='passport'">
                          Passport</option>
                        <option _ngcontent-c2="" value="aadhar" [selected]="uniqueIdentification=='aadhar'">Aadhar
                          Number</option>
                        <option _ngcontent-c2="" value="voterId" [selected]="uniqueIdentification=='voterId'">Voter's Id
                        </option>
                        <option _ngcontent-c2="" value="others" [selected]="uniqueIdentification=='others'">others
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-md-4 col-sm-6 col-xs-12"
                      *ngIf="personaldetailsForm.controls.uin.value == 'passport' ">
                      <label>Passport Number</label>
                      <input type="text" class="form-control"
                        [formControl]="personaldetailsForm.controls['passportNumber']">
                      <div
                        *ngIf="personaldetailsForm.controls['passportNumber'].hasError('pattern')|| personaldetailsForm.controls['passportNumber'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Passport Number is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12"
                      *ngIf="personaldetailsForm.controls.uin.value == 'aadhar'  ">
                      <label>Aadhaar Number</label>
                      <input type="text" class="form-control"
                        [formControl]="personaldetailsForm.controls['adharNumber']">
                      <div
                        *ngIf="personaldetailsForm.controls['adharNumber'].hasError('pattern')|| personaldetailsForm.controls['adharNumber'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Aadhaar Number is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12"
                      *ngIf="personaldetailsForm.controls.uin.value == 'voterId' ">
                      <label>Voter's Id</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['voterId'] ">
                      <div
                        *ngIf="personaldetailsForm.controls['voterId'].hasError('pattern')|| personaldetailsForm.controls['voterId'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Voter's Id is invalid
                      </div>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-12"
                      *ngIf="personaldetailsForm.controls.uin.value == 'others' ">
                      <label>Others</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['others']">
                      <div
                        *ngIf="personaldetailsForm.controls['others'].hasError('pattern')|| personaldetailsForm.controls['others'].hasError('maxlength')"
                        class="form-control-error-custom">
                        Others is invalid
                      </div>
                    </div> -->

                    <div class="form-group col-md-4 col-sm-6 col-xs-12">
                      <label>E-mail Id</label>
                      <input type="text" class="form-control" [formControl]="personaldetailsForm.controls['emailid']">
                      <div *ngIf="personaldetailsForm.controls['emailid'].hasError('pattern')|| personaldetailsForm.controls['emailid'].hasError('maxlength')"
                        class="form-control-error-custom">
                        E-mail Id is invalid
                      </div>
                    </div>
                  </div>
                </div>
                <!--------------------- others Shareholders --------------------->

              </form>

              <div class="form-group" align="right" *ngIf="addPersonaldetailsBtn">
                <button class="btn btn-sm btn-primary" (click)="updatePersonalDetails()" type="button" [disabled]="!personaldetailsForm.valid || !fileExtension || disabledOnClick">
                  <span id="saveUpdateDirector">Save</span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="!addPersonaldetailsBtn">
                <button class="btn btn-sm btn-primary" (click)="updatePersonalDetails()" type="button" [disabled]="!personaldetailsForm.valid || !fileExtension || disabledOnClick">
                  <span id="saveUpdateDirector">Update</span>
                </button>
              </div>

            </div>
          </div>
        </div>

        <!--------------------- details of members --------------------->
        <div class="tab-pane" id="detailsOfMember" role="tabcard">
          <div class="modal-body">

            <div class="form-group col-sm-6 col-lg-12">
              <!-- <div  class="row" > -->
              <form [formGroup]='detailsOfMembersForm' (document:click)="aa.close();bb.close();cc.close();dd.close()">
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of becoming member</label>
                    <span _ngcontent-c1="" style="color: red;">*</span>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="detailsOfMembersForm.controls.doBecomingMember" [(ngModel)]="dateOfBecomingMember"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #aa="ngbDatepicker" (click)="aa.toggle();cc.close();bb.close();dd.close()">
                      <button class="input-group-addon" (click)="aa.toggle();cc.close();bb.close();dd.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                    <div *ngIf="detailsOfMembersForm.controls['doBecomingMember'].hasError('required') && detailsOfMembersForm.controls['doBecomingMember'].touched"
                      class="form-control-error-custom">
                      Date of becoming member is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of declaration under section 89, if applicable</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="detailsOfMembersForm.controls.dateOfDeclaration" [(ngModel)]="doDeclaration" style="padding:6px;z-index: 0;"
                        placeholder="dd-mm-yyyy" ngbDatepicker #bb="ngbDatepicker" (click)="bb.toggle();aa.close();cc.close();dd.close()">
                      <button class="input-group-addon" (click)="bb.toggle();aa.close();cc.close();dd.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Add Note related to declaration under section 89</label>
                    <textarea class="form-control" [formControl]="detailsOfMembersForm.controls.addNoterelatedToDeclaration" maxlength="200"> </textarea>
                    <div *ngIf="detailsOfMembersForm.controls['addNoterelatedToDeclaration'].hasError('pattern') || detailsOfMembersForm.controls['addNoterelatedToDeclaration'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Add Note related to declaration under section 89 is invalid
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Name of beneficial owner</label>
                    <input type="text" class="form-control" [formControl]="detailsOfMembersForm.controls['nameOfBeneficialowner']">
                    <div *ngIf="detailsOfMembersForm.controls['nameOfBeneficialowner'].hasError('pattern') || detailsOfMembersForm.controls['nameOfBeneficialowner'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Name of beneficial owner is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Address of beneficial owner</label>
                    <textarea class="form-control" [formControl]="detailsOfMembersForm.controls.addressOfBeneficialOwner" maxlength="200"> </textarea>
                    <div *ngIf="detailsOfMembersForm.controls['addressOfBeneficialOwner'].hasError('pattern') || detailsOfMembersForm.controls['addressOfBeneficialOwner'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Address of beneficial owner is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of receipt of nomination, if applicable</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="detailsOfMembersForm.controls.doReceiptOfNomination" [(ngModel)]="dateOfReceiptOfNomination"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #cc="ngbDatepicker" (click)="cc.toggle();aa.close();bb.close();dd.close()">
                      <button class="input-group-addon" (click)="cc.toggle();aa.close();bb.close();dd.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Name and Address of Nominee</label>
                    <textarea class="form-control" [formControl]="detailsOfMembersForm.controls.nameAndAddressOfNominee" maxlength="200"> </textarea>
                    <div *ngIf="detailsOfMembersForm.controls['nameAndAddressOfNominee'].hasError('pattern') || detailsOfMembersForm.controls['nameAndAddressOfNominee'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Name and Address of Nominee is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>No. of shares kept in abeyance, if applicable</label>
                    <input type="text" class="form-control" [formControl]="detailsOfMembersForm.controls['noOfSharesKeptInAbeyance']">
                    <div *ngIf="detailsOfMembersForm.controls['noOfSharesKeptInAbeyance'].hasError('pattern') || detailsOfMembersForm.controls['noOfSharesKeptInAbeyance'].hasError('maxlength')"
                      class="form-control-error-custom">
                      No. of shares kept in abeyance is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Record of lien on shares, if applicable</label>
                    <input type="text" class="form-control" [formControl]="detailsOfMembersForm.controls['recordOfLienOnShares']">
                    <div *ngIf="detailsOfMembersForm.controls['recordOfLienOnShares'].hasError('pattern') || detailsOfMembersForm.controls['recordOfLienOnShares'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Record of lien on shares is invalid
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of cessation of membership</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="detailsOfMembersForm.controls.doCessationOfMemebership" [(ngModel)]="dateOfCessation"
                        style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #dd="ngbDatepicker" (click)="dd.toggle();aa.close();bb.close();cc.close()">
                      <button class="input-group-addon" (click)="dd.toggle();aa.close();bb.close();cc.close()" type="button">
                        <span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Particulars of dividend mandates, power of attorney and other instructions, if any</label>
                    <input type="text" class="form-control" [formControl]="detailsOfMembersForm.controls['particularsOfDmPoa']">
                    <div *ngIf="detailsOfMembersForm.controls['particularsOfDmPoa'].hasError('pattern') || detailsOfMembersForm.controls['particularsOfDmPoa'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Particulars of dividend mandates, power of attorney and other instructions is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Amount of Guarantee, if any </label>
                    <input type="text" class="form-control" [formControl]="detailsOfMembersForm.controls['amountOfGuaranee']">
                    <div *ngIf="detailsOfMembersForm.controls['amountOfGuaranee'].hasError('pattern') || detailsOfMembersForm.controls['amountOfGuaranee'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Amount of Guarantee is invalid
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Any other interest, if any</label>
                    <textarea class="form-control" [formControl]="detailsOfMembersForm.controls.anyOtherInterest" maxlength="200"> </textarea>
                    <div *ngIf="detailsOfMembersForm.controls['anyOtherInterest'].hasError('pattern') || detailsOfMembersForm.controls['anyOtherInterest'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Any other interest is invalid
                    </div>
                  </div>

                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Instruction for sending notices etc., if any</label>
                    <textarea class="form-control" [formControl]="detailsOfMembersForm.controls.instructionForSendingNotices" maxlength="200"> </textarea>
                    <div *ngIf="detailsOfMembersForm.controls['instructionForSendingNotices'].hasError('pattern') || detailsOfMembersForm.controls['instructionForSendingNotices'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Instruction for sending notices is invalid
                    </div>
                  </div>

                </div>

              </form>

              <div class="form-group" align="right" *ngIf="addDomBtn">
                <button class="btn btn-sm btn-primary" (click)="updateDetailsOfMembers()" type="button" [disabled]="!detailsOfMembersForm.valid || disabledOnClick">
                  <span id="saveUpdateDirector">Save</span>
                </button>
              </div>
              <div class="form-group" align="right" *ngIf="!addDomBtn">
                <button class="btn btn-sm btn-primary" (click)="updateDetailsOfMembers()" type="button" [disabled]="!detailsOfMembersForm.valid || disabledOnClick">
                  <span id="saveUpdateDirector">Update</span>
                </button>
              </div>
              <!-- </div> -->
            </div>

          </div>
        </div>

        <!-- details of shareholding -->
        <div class="tab-pane" id="detailsOfShareholding" role="tabcard">
          <div class="form-group clearfix" style="margin-bottom: 1px;">
            <div class="col-sm-12">
              <button class="btn btn-success pull-right" (click)="addNewFieldsModal()" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}"
                class="btn btn-sm btn-primary mb-2" type="button" style="margin-top: 10px; float:right">
                <i class="fa fa-plus"></i>&nbsp;Add</button>
            </div>
          </div>



           <!-- Date Filter  -->
  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
          class="fa fa-filter" aria-hidden="true"></i></span> </div>
    <div class="card-block collapse" id="search-div"  [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
           
          

            <div class="col-md-3">
              <br>
              <!-- <label> Date of Date of transfer/ transmission/ forfeiture / redemption etc of membership</label> -->
              <div class="input-group" (click)="$event.stopPropagation()">
                From :&nbsp;
                <input id="dateFrom" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateFrom" ngbDatepicker
                  #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateFrom">
                <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
              
              </div>
            </div>


            <div class="col-md-3">
              <br>
              <!-- <label> Date of Date of allotment/ transfer </label> -->
              <div class="input-group" (click)="$event.stopPropagation()">
              
                 To :&nbsp;
                <input id="dateTo" class="form-control" [minDate]="futureToDateTo"
                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateTo" ngbDatepicker
                #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateTo">
              <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
              </button>
              </div>
            </div>






            <div class="col-md-4 col-sm-6 col-xs-12">
              <label>&nbsp;&nbsp;&nbsp;</label>
              <div class="input-group">
                <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                  <i class="fa fa-search"></i>&nbsp;Search</button>
                &nbsp;&nbsp;&nbsp;
                <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                  (click)="clearAdvSearch()">
                  <i class="fa fa-refresh"></i>&nbsp;Clear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Date filter End -->
   <!-- Details of Holding List Table -->

          <div class="card-block datatable-card-block">
            <div class="row">
              <div class="col-md-12">
                <div class="margin-bottom-50">
                  <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptionsOfHolding" [dtTrigger]="dtTriggerHolding" class="table table-hover compact cell-border nowrap stripe"
                      id="detailsOfHoldinglistTable" style="cursor: pointer;">
                      <thead>
                        <tr>
                          <th>Types</th>
                          <th>Allotment No./<br> Transfer No.</th>
                          <!-- <th>Date of allotment/ transfer</th> -->
                          <th>Certificate No.</th>

                          <th>Date of transfer/<br> transmission/ forfeiture/<br>redemption etc of membership </th>
                         
                          <th> Date of allotment/<br> transfer</th>
                         
                          <!-- <th>No. of shares allotted/ transferred</th> -->
                          <th style="width: 175px">Action</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let i of holdingList;">
                          <td>{{i.detailsOfHoldings.typesOfHolders}}</td>
                          <td>{{i.detailsOfHoldings.allotmentNo}}</td>
                          <!-- <td>{{i.dateOfAllotment}}</td> -->
                          <td>{{i.detailsOfHoldings.certificateNo}}</td>
                          <!-- <td>{{i.noOfSharesAlloted}}</td> -->

                  <td>
                    {{i.detailsOfHoldings.dateOfTransfer  | date: 'dd-MM-yyyy'}}
                  </td>

                  <td>
                    {{i.detailsOfHoldings.dateOfAllotment  | date: 'dd-MM-yyyy'}}
                  </td>





                          <td style='white-space: nowrap; width: 118px'>
                            <a>
                              <button type="button" (click)="editholdingdetails(i.detailsOfHoldings._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(i.detailsOfHoldings._id)" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}">
                                <span class="icmn-bin"></span>
                              </button>
                            </a>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    Are you sure you want to delete shareholding details?
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" (click)="deleteholdingdetail()">
                  <i class="fa fa-check"></i>&nbsp;Yes
                </button>
                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                  <i class="fa fa-times"></i>&nbsp;No
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade" id="addNewForm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true" style="top: 50px;"
          data-backdrop="static" data-keyboard="false">
          <div class="modal-dialog dynamicFieldModal" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Add Details of holding</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" (click)="resetFields()" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    <button class="btn btn-success pull-right" (click)="addNewFields()" *ngIf="addholding" [appHasPermission]="{'Url': '/register/mgt1list/edit?goveva=true&email=', 'method':'put', 'menu': 'mgt1list'}"
                      class="btn btn-sm btn-primary mb-2" type="button" style="margin-top: -5px; margin-bottom: 15px !important; float: right">
                      <i class="fa fa-plus"></i>&nbsp;Add</button>
                    <form [formGroup]="addNewTermsheetFieldForm" class="form-horizontal">

                      <div class="col-md-12 clearfix" formArrayName="newField" *ngFor="let Field of newFieldArray; let i = index;" style="overflow-x: auto; border: 1px solid #b2d0ce; margin-bottom: 20px; padding: 15px;">
                        <div [formGroupName]="i">
                          <div class="row">
                            <div class="col-md-12">
                              <table style="margin-bottom: 10px; width: auto; min-width: 100%;">
                                <tbody>
                                  <!-- ALL Labels in ONE Row -->
                                  <tr>
                                    <td style="padding: 5px; min-width: 150px;"><label [attr.for]="'typesOfHolders' + i">Types<span style="color: red;">*</span></label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label [attr.for]="'allotmentNo' + i">Allotment No./ Transfer No.</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Date of allotment/ transfer</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>No. of shares allotted/ transferred</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Distinctive numbers (From)</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Distinctive numbers (To)</label></td>
                                    <td style="padding: 5px; min-width: 150px;" *ngIf="addNewTermsheetFieldForm.controls.newField.value[i]['typesOfHolders'] == 'Transfer' "><label [attr.for]="'folioOfTransferor' + i">Folio of transferor</label></td>
                                    <td style="padding: 5px; min-width: 150px;" *ngIf="addNewTermsheetFieldForm.controls.newField.value[i]['typesOfHolders'] == 'Transfer' "><label [attr.for]="'nameOfTransferor' + i">Name of transferor</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Date of issue or endorsement</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label [attr.for]="'certificateNo' + i">Certificate No.<span style="color: red;">*</span></label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Lock in period</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Amount (Rs) Payable</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Amount (Rs) Paid</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Amount (Rs) Due</label></td>
                                    <td style="padding: 5px; min-width: 200px;"><label>If shares issued for consideration other than cash</label></td>
                                    <td style="padding: 5px; min-width: 150px;"><label>Date of transfer/transmission/forfeiture</label></td>
                                    <td style="padding: 5px; min-width: 200px;"><label>Remarks</label></td>
                                    <td style="padding: 5px; min-width: 80px;"><label>Action</label></td>
                                  </tr>
                                  
                                  <!-- ALL Inputs in ONE Row -->
                                  <tr>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <select class="form-control" name="typesOfHolders" id="typesOfHolders" formControlName="typesOfHolders" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders']"
                                        (change)="typesOfHoldersChanged()" [value]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value" style="padding:6px;">
                                        <option value="" [selected]="true">Select Type</option>
                                        <option value="Allotment" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Allotment'">Allotment</option>
                                        <option value="Transfer" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Transfer'">Transfer</option>
                                        <option value="Transmission" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Transmission'">Transmission</option>
                                        <option value="Forfeiture" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Forfeiture'">Forfeiture</option>
                                        <option value="Demat" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Demat'">Demat</option>
                                        <option value="Splitting of Shares" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Splitting of Shares'">Splitting of Shares</option>
                                        <option value="Redemption" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Redemption'">Redemption</option>
                                        <option value="Buy Back" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Buy Back'">Buy Back</option>
                                        <option value="Others" [selected]="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].value=='Others'">Others</option>
                                      </select>
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].hasError('required') && addNewTermsheetFieldForm.controls.newField.controls[i].controls['typesOfHolders'].touched" class="form-control-error-custom">Required</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" id="allotmentNo" [name]="'allotmentNo' + i " formControlName="{{'allotmentNo'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.allotmentNo">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['allotmentNo'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['allotmentNo'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.dateOfAllotment" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle();a.close();">
                                        <button class="input-group-addon" (click)="b.toggle();a.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                      </div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.noOfSharesAlloted" formControlName="{{'noOfSharesAlloted'}}">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['noOfSharesAlloted'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['noOfSharesAlloted'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" formControlName="{{'distinctiveFrom'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.distinctiveFrom">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['distinctiveFrom'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['distinctiveFrom'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" formControlName="{{'distinctiveTo'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.distinctiveTo">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['distinctiveTo'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['distinctiveTo'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;" *ngIf="addNewTermsheetFieldForm.controls.newField.value[i]['typesOfHolders'] == 'Transfer' ">
                                      <input type="text" class="form-control" id="folioOfTransferor" [name]="'folioOfTransferor' + i" formControlName="{{'folioOfTransferor'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.folioOfTransferor">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['folioOfTransferor'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['folioOfTransferor'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;" *ngIf="addNewTermsheetFieldForm.controls.newField.value[i]['typesOfHolders'] == 'Transfer' ">
                                      <input type="text" class="form-control" id="nameOfTransferor" [name]="'nameOfTransferor' + i" formControlName="{{'nameOfTransferor'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.nameOfTransferor">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['nameOfTransferor'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['nameOfTransferor'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.dateOfIssue" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();b.close();">
                                        <button class="input-group-addon" (click)="a.toggle();b.close();" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                      </div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" [id]="'certificateNo' + i " [name]="'certificateNo' + i " formControlName="{{'certificateNo'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.certificateNo" [value]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.certificateNo.value">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls.certificateNo.hasError('required') && addNewTermsheetFieldForm.controls.newField.controls[i].controls.certificateNo.touched" class="form-control-error-custom">Required</div>
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['certificateNo'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['certificateNo'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" id="lackInPeriod" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.lackInPeriod" formControlName="{{'lackInPeriod'}}">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['lackInPeriod'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['lackInPeriod'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.amountPayable" formControlName="{{'amountPayable'}}">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['amountPayable'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['amountPayable'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.amountPaid" formControlName="{{'amountPaid'}}">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['amountPaid'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['amountPaid'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <input type="text" class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.amountDue" formControlName="{{'amountDue'}}">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['amountDue'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['amountDue'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 200px;">
                                      <input type="text" class="form-control" id="sharesIssued" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.sharesIssued" formControlName="{{'sharesIssued'}}">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['sharesIssued'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['sharesIssued'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style="padding: 5px; min-width: 150px;">
                                      <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.dateOfTransfer" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" ngbDatepicker #dd="ngbDatepicker" (click)="dd.toggle()">
                                        <button class="input-group-addon" (click)="dd.toggle()" type="button"><span class="fa fa-calendar" style="width: 1rem; height: 0.7rem; cursor: pointer;"></span></button>
                                      </div>
                                    </td>
                                    <td style="padding: 5px; min-width: 200px;">
                                      <input type="text" class="form-control" [id]="remarks" [name]="'remarks' + i " formControlName="{{'remarks'}}" [formControl]="addNewTermsheetFieldForm.controls.newField.controls[i].controls.remarks">
                                      <div *ngIf="addNewTermsheetFieldForm.controls.newField.controls[i].controls['remarks'].hasError('pattern')|| addNewTermsheetFieldForm.controls.newField.controls[i].controls['remarks'].hasError('maxlength')" class="form-control-error-custom">Invalid</div>
                                    </td>
                                    <td style='padding: 5px; min-width: 80px; text-align:center; vertical-align:middle;'>
                                      <button type="button" class="btn-sm btn btn-danger" (click)="removeField(i)" *ngIf="addholding"><span class="icmn-bin"></span></button>
                                    </td>
                                  </tr>

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" *ngIf="addholding" (click)="saveDetailsOfHolding()" [disabled]="!(addNewTermsheetFieldForm.valid) || disabledOnClick">
                  <i class="fa fa-check"></i>&nbsp;Save
                </button>
                <button type="button" class="btn btn-sm btn-primary" *ngIf="!addholding" (click)="updateHoldingDetails()" [disabled]="!(addNewTermsheetFieldForm.valid) || disabledOnClick">
                  <i class="fa fa-check"></i>&nbsp;Update
                </button>

                <button type="button" class="btn btn-sm btn-danger" data-dismiss="modal" (click)="resetFields()">
                  <i class="fa fa-times"></i>&nbsp;No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- details of shareholding end -->


    </div>
  </div>




</section>